import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  Validators,
  FormGroup,
} from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
  selector: "technical-issue-ticket",
  templateUrl: "./technical-issue-ticket.component.html",
  styleUrls: ["./technical-issue-ticket.component.scss"],
})
export class TechnicalIssueTicketComponent implements OnInit, OnChanges {
  @Input() category: string;
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }
  onFileSelect(file: FileInput) {
    this.form.get("screenshot").setValue({
      name: file.file.name,
      content: file.base64,
    });
  }
  onFileRemove() {
    this.form.get("screenshot").reset();
  }

  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }

  get message() {
    return this.form.get("message");
  }
  get screenshot() {
    return this.form.get("screenshot");
  }

  initiateForm() {
    this.form.addControl(
      "screenshot",
      new FormControl(
        null,
        this.category == "buySellIssueErrorPlacingOrder"
          ? Validators.required
          : []
      )
    );
    this.form.addControl("message", new FormControl("", Validators.required));
  }
}
